import React, { useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { useSearchParams } from 'next/navigation';

import { AuthProvider } from './model/auth-provider';
import { AuthManagementContent } from './ui/auth-management-content';

interface AuthManagementProps {
  visible: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const KEY_AUTH = {
  VERIFICATION: 'verification',
  REGISTRATION: 'registration',
  AUTH: 'auth',
};

export const AuthManagement: React.FC<AuthManagementProps> = ({
  visible,
  onOpen,
  onClose,
}) => {
  const searchParams = useSearchParams();

  const { modal, recoveryCode } = {
    modal: searchParams.get('modal'),
    recoveryCode: searchParams.get('recoveryCode'),
  };

  useEffect(() => {
    if (
      modal === KEY_AUTH.VERIFICATION ||
      modal === KEY_AUTH.REGISTRATION ||
      modal === KEY_AUTH.AUTH ||
      recoveryCode
    ) {
      onOpen();
    }
  }, [modal, recoveryCode]);

  return (
    <Dialog.Root open={visible} onOpenChange={onOpen}>
      <Dialog.Portal>
        <AuthProvider visible={visible} onOpen={onOpen} onClose={onClose}>
          <AuthManagementContent />
        </AuthProvider>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
